
<template>

    <div id="cropmemain" class="col-md-10" main> 
      <div class="row pg-empty-placeholder">
          <div class="col-md-8">
              <img id="coverbild" :src="url_fuer_coverbild()" style="max-width:600px;">
              
              <h3>Hochgeladenes Bild</h3>
              <p>Bitte mit der Maus einen Rahmen ziehen. Danach "Beschneiden" klicken und dann "Freigeben".</p>
              <p>Das Bild steht dann sofort ihrem Findus zur Verfügung.</p>

              <p></p>
          </div>

          <div class="col-md-1">
              <!-- nix -->
          </div>
          <!-- das ist die rechte Spalte -->
          <div id="spalterechts" class="col-md-3">
              <h3 v-if="! suchurl_bei_customer">Vorgang {{ vorgang_id }}/{{ customer }}</h3>
              <h3 v-if="suchurl_bei_customer">Vorgang {{ vorgang_id }}/<a v-bind:href="suchurl_bei_customer" target="findussuche">{{ customer }}</a></h3>
              <p>nichts -> nur resize</p>
              <b-button @click="fertigmitcrop" type="button" class="btn btn-primary btn-lg btn-block"
              v-show="freigabe_ist_moeglich">Beschneiden</b-button>

              
              <b-alert variant="warning" show
                v-show="!freigabe_ist_moeglich">Freigabe nicht möglich, EAN?</b-alert>

              <br>
              <br>

              <b-button @click="freigabe_machen" type="button" 
                class="btn btn-success btn-lg btn-block"
                v-show="freigabe_ist_moeglich"
                title="Erst beschneiden, dann freigeben..."
                :disabled="! bild_ist_beschnitten">Freigeben</b-button>
              <br>

              <div id="cropped_cover_90" class="cropped_cover" v-if="url_fuer_cropped_coverbild_90">
                  <img :src="url_fuer_cropped_coverbild_90">
              </div>
              <div id="cropped_cover_200" class="cropped_cover" v-if="url_fuer_cropped_coverbild_200">
                  <img :src="url_fuer_cropped_coverbild_200">
              </div>
              <br>

              
              <br>
              <h3>Was schiefgelaufen...</h3>
              <b-button @click="drehmich"
                v-show="freigabe_ist_moeglich">Dreh mich</b-button>
              <br>
              <br>
              <div>
                <p>EAN-Nummer manuell eingeben:</p>
                <div v-show="ean_manuell_rueckmeldung_anzeigen" 
                    class="alert" 
                    v-bind:class="{ 
                        'alert-success': ean_manuell_rueckmeldung_ist_gut,
                        'alert-warning': ! ean_manuell_rueckmeldung_ist_gut }"
                    role="alert">{{ ean_manuell_rueckmeldung_text }}</div>
                <input type="text" v-model="ean_manuell" placeholder="123-456-789-012-3">
                &nbsp;<button @click="ean_manuell_eingeben" vtype="button" class="btn btn-info" data-toggle="tooltip" 
                  title="EAN-Nummer direkt eingeben">Ok</button>
              </div>
              <br>

              <button @click="loesche_den_vorgang" vtype="button" class="btn btn-danger" data-toggle="tooltip" 
                title="Hochgeladenes Bild komplett löschen">Vorgang komplett löschen</button>
              <br>
              <br>
              <button 
                @click="gehe_zum_naechsten_vorgang"
                type="button" class="btn btn-warning"
                v-show="freigabe_ist_moeglich">Doch nicht bearbeiten, next</button>
              <br>
              <br>
              <h3>Medieninfo</h3>
              <p>Diese Infos kommen von Findus...</p> 
            
              <h4>Autor:</h4>
              <p v-if="autor">{{ autor }}</p>
              <p v-if="! autor"><i>nicht bekannt</i></p>
            
              <h4>Titel:</h4>
              <p v-if="titel">{{ titel }}</p>
              <p v-if="! titel"><i>nicht bekannt</i></p>
              
              <h4>Barcode der Bücherei:</h4>
              <p v-if="barcode">{{ barcode }}</p>
              <p v-if="! barcode"><i>nicht bekannt</i></p>

              <h4>EAN:</h4>
              <p v-if="ean">{{ ean }}</p>
              
              <p v-if="! ean"><i>nicht bekannt</i></p>
              <p v-if="ean_herkunft"><i>{{ ean_herkunft }}</i></p>
          </div>
      </div>
    </div>

</template>

<script>
// um das geht's hier, Markieren des Bildausschnitts mit Cropper
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import axios from 'axios';

// Mixin fuer diese Komponente importieren
import loginzustand from './mixins/loginzustand.js';
import commonvars from './mixins/commonvars.js';

export default {
    props: [
        'vorgang_id',
        'customer'
    ],
    mounted: function() {
        this.api_loginzustand_feststellen();
        this.get_vorgang_infos();
        this.starte_cropper();
    },
    mixins: [
        loginzustand,
        commonvars
    ],
    data() {
        return {
            cropper: '',
            // Cropperauswahl:
            auswahl: {
                "start_x": 0,
                "start_y": 0,
                "breite": 0,
                "hoehe": 0,
                "rotate": 0,
                "vorgang_id": this.vorgang_id,
                "uploader": this.uploader
            },
            ean_manuell: "",
            ean_manuell_rueckmeldung_anzeigen: false,
            ean_manuell_rueckmeldung_ist_gut: false,
            ean_manuell_rueckmeldung_text: "",

            // mit dieser URL stoße ich direkt eine Findus-Suche an
            suchurl_bei_customer: "",

            // Cropper sendet immer den wirklichen Drehwinkel
            // +90 Grad wenn ich einen Rahmen setze. Deswegen
            // merke ich mir den Drehwinkel den der User setzt hier:
            rotate_durch_user: 0,
            titel: '',
            autor: '',
            ean: '',
            ean_herkunft: '',
            barcode: '',
            // customer ist hier prop
            url_fuer_cropped_coverbild_90: '',
            url_fuer_cropped_coverbild_200: '',
            freigabe_ist_moeglich: false,
            bild_ist_beschnitten: false
        }
    },
    methods: {
    
        drehmich() {
            console.log("drehmich");
            // es geht JEDER Winkel, nicht nur 90 Grad
            let drehwinkel = 90;
            this.rotate_durch_user += drehwinkel;
            this.rotate_durch_user = this.rotate_durch_user % 360;
            this.cropper.rotate(drehwinkel);
            },
            speichere_auswahl(event) {
            this.auswahl = {
                "start_x": event.detail.x,
                "start_y": event.detail.y,
                "breite": event.detail.width,
                "hoehe": event.detail.height,
                "rotate": event.detail.rotate,
                "vorgang_id": this.vorgang_id,
                "uploader": this.uploader
            };
        },
        starte_cropper() {
            console.log("Starte Cropper");
            let image = document.getElementById('coverbild');
            let that = this;
            this.cropper = new Cropper(image, {
                viewMode: 1,
                autoCrop: false,
                zoomable: false,
                crop(event) {
                // ich kann hier nicht mit this arbeiten, also that
                that.speichere_auswahl(event);
                },
            });
        },
        fertigmitcrop() {
            // melde den Auftrag an den Server, dass dort
            // das Bild ausgeschnitten werden soll
            let crop_url = this.api_cropcover_url();
            console.log("cropcover wurde angestoßen, url " + crop_url);

            // cropper rotiert immer +90 obwohl ich gar nicht rotiert habe -> richtigstellen
            this.auswahl.rotate = this.rotate_durch_user;

            console.log(this.auswahl);
            console.log("rotate ist " + this.auswahl.rotate);

            axios.post(crop_url, this.auswahl )
                .then(
                    response => {
                        console.log(response);
                        console.log("Crop ist vom Server angenommen worden, hole neue Infos zum Vorgang");
                        this.get_vorgang_infos();
                        this.bild_ist_beschnitten = true
                    }
                );
        },
        gehe_zum_naechsten_vorgang() {
            console.log("Gehe zum nächsten Vorgang");
            this.weiterleitung_zum_naechsten_vorgang_der_zu_bearbeiten_ist();
        },
        api_cropcover_url() {
            return this.server_base_url()
                + '/api/cover/uploader/'
                + this.customer
                + '/vorgang/'
                + this.vorgang_id
                + '/cropcover';
        },
        api_freigabe_url() {
            return this.server_base_url()
                + '/api/vorgang/'
                + this.vorgang_id
                + '/customer/'
                + this.customer
                + '/freigabe';
        },
        api_loesche_vorgang_url() {
            return this.server_base_url()
                + '/api/vorgang/'
                + this.vorgang_id
                + '/customer/'
                + this.customer
                + '/loeschen';
        },
        api_ean_manuell_eingeben_url() {
            return this.server_base_url()
                + '/api/vorgang/'
                + this.vorgang_id
                + '/customer/'
                + this.customer
                + '/ean/manuell/'
                + this.ean_manuell;
        },
        findus_such_url_fuer_diese_ean_in_findus(ean) {
            return "https://" + this.customer
                + ".findus-internet-opac.de"
                + "/cgi-bin/findus.pl?customer="
                + this.customer
                + "&suchart_welche_maske_ist_sichtbar=experte"
                + "&suchfeld1=isbn&wildcard1=beginntmit"
                + "&suchfeld1_inhalt=" + ean
                + "&medientyp=*&submit=1"
        },
        loesche_den_vorgang() {
            let url = this.api_loesche_vorgang_url();
            console.log(url);
            axios
                .post(url)
                .then(
                    response => {
                        console.log("Vorgang wurde geloescht");
                        console.log(response.data);
                        this.weiterleitung_zum_ersten_vorgang_der_zu_bearbeiten_ist();
                    }
                )
                .catch(
                () => {
                    console.log("unauthorized -> login");
                    this.$router.push("/login");
                }
            );

        },
        ean_manuell_eingeben() {
            // User hat nicht eingegeben... gar nicht an den Server weiterleiten
            if (this.ean_manuell.length == 0) {
                this.ean_manuell_rueckmeldung_anzeigen = true
                this.ean_manuell_rueckmeldung_ist_gut = false
                this.ean_manuell_rueckmeldung_text = "Bitte 13-stellige EAN..."

                // Meldung wieder ausblenden
                setTimeout(() => this.ean_manuell_rueckmeldung_anzeigen = false, 3000)

                // versuche jetzt Details für das Medium von Findus zu bekommen
                // damit es rechts unten angezeigt wird:
                this.get_vorgang_infos();
                return;
            }

            let url = this.api_ean_manuell_eingeben_url();
            console.log(url);
            axios
                .post(url)
                .then(
                    response => {
                        console.log("Manueller EAN-Update wurde beantwortet");
                        console.log(response.data);

                        this.ean_manuell_rueckmeldung_anzeigen = true
                        if (response.data.ok == 1) {
                            this.ean_manuell_rueckmeldung_ist_gut = true
                            this.ean_manuell_rueckmeldung_text = "Ok, EAN wurde so angenommen"
                            this.freigabe_ist_moeglich = true

                            // mit der Befüllung dieser Variable wird ein Link für Findus
                            // aktiviert mit dem man diese URL direkt in Findus suchen kann
                            this.suchurl_bei_customer = this.findus_such_url_fuer_diese_ean_in_findus(this.ean_manuell)
                        } else {
                            this.ean_manuell_rueckmeldung_ist_gut = false
                            this.ean_manuell_rueckmeldung_text = response.data.fehler_message
                        }

                        // Meldung wieder ausblenden
                        setTimeout(() => this.ean_manuell_rueckmeldung_anzeigen = false, 3000)
                    }
                )
                .catch(
                () => {
                    console.log("unauthorized -> login");
                    this.$router.push("/login");
                }
            );
        },
        freigabe_machen() {
            if (this.ean) {
                console.log("EAN gefunden, dann kann ich auch den Cache loeschen, EAN=" + this.ean);
                this.loesche_findus_covercache_fuer_ean();
            }
            this.freigeben();
        },
        freigeben() {
            let url = this.api_freigabe_url();
            console.log(url);
            axios
                .post(url)
                .then(
                    response => {
                        console.log("Ergebnis von Freigabe");
                        console.log(response.data);
                        this.weiterleitung_zum_ersten_vorgang_der_zu_bearbeiten_ist();
                    }
                )
                .catch(
                    () => {
                        console.log("unauthorized -> login");
                        this.$router.push("/login");
                    }
                );
        },
        api_loesche_findus_covercache_fuer_ean_url() {
            return this.server_base_url()
                + '/api/findus/customer/'
                + this.customer
                + '/mycovercache/loesche/ean/'
                + this.ean;
        },
        loesche_findus_covercache_fuer_ean() {
            let url = this.api_loesche_findus_covercache_fuer_ean_url();
            console.log(url);
            axios
                .post(url)
                .then(
                    response => {
                        console.log("Ergebnis von loesche_findus_covercache_fuer_ean_url ist:");
                        console.log(response.data);
                    }
                )
                .catch(
                    () => {
                        console.log("unauthorized -> login");
                        this.$router.push("/login");
                    }
                );

        },
        weiterleitung_zum_ersten_vorgang_der_zu_bearbeiten_ist()  {
            console.log("Hole aktuelle offene Vorgaenge");
            let url = this.api_offene_vorgaenge_url();
            axios
                .get(url)
                .then(
                    response => {
                        console.log(response.data);
                        if (response.data.anzahl_offene_vorgaenge > 0) {
                            console.log("Ich habe offene Vorgaenge bekommen");
                            let erster_offener_vorgang = response.data.offene_vorgaenge[0];
                            console.log("Erster offener Vorgang ist " + erster_offener_vorgang);
                            let neue_url = "/cropme/"
                                + this.customer
                                + "/vorgang/"
                                + erster_offener_vorgang;
                            this.$router.push(neue_url);
                        } else {
                            console.log("Ich habe keine offenen Vorgaenge bekommen");
                            let neue_url = "/cropme"
                            this.$router.push(neue_url);
                        }
                    }
                )
                .catch(
                    () => {
                        console.log("unauthorized -> login");
                        this.$router.push("/login");
                    }
                );
        },
        weiterleitung_zum_naechsten_vorgang_der_zu_bearbeiten_ist()  {
            console.log("Hole aktuelle offene Vorgaenge");
            let url = this.api_offene_vorgaenge_url();
            axios
                .get(url)
                .then(
                    response => {
                        let alte_vorgang_id = this.vorgang_id;
                        console.log(response.data);
                        if (response.data.anzahl_offene_vorgaenge == 0) {
                            console.log("Ich habe keine offenen Vorgaenge bekommen");
                            let neue_url = "/cropme"
                            this.$router.push(neue_url);
                            return;
                        }
                        
                        console.log("Ich habe offene Vorgaenge bekommen");
                        // suche den alten Vorgang in der Liste der IDs.
                        // ich brauche aber den nächsten Vorgang
                        let naechste_vorgang_id = -1;
                        let alter_vorgang_index = 0;
                        for (let i=0; i < response.data.offene_vorgaenge.length; i++) {
                            if (response.data.offene_vorgaenge[i] == alte_vorgang_id) {
                                console.log("alter_vorgang_index = " + alter_vorgang_index);
                                alter_vorgang_index = i;
                                break;
                            }
                        }
                        if (alter_vorgang_index +1  < response.data.offene_vorgaenge.length) {
                            naechste_vorgang_id = response.data.offene_vorgaenge[alter_vorgang_index + 1] ;
                        }
                        if (alter_vorgang_index +1 == response.data.offene_vorgaenge.length) {
                            naechste_vorgang_id = response.data.offene_vorgaenge[0];
                        }
                        
                        console.log("Nächster offener Vorgang ist " + naechste_vorgang_id);
                        let neue_url = "/cropme/"
                            + this.customer
                            + "/vorgang/"
                            + naechste_vorgang_id;
                        this.$router.push(neue_url);
                    }
                )
                .catch(
                    () => {
                        console.log("unauthorized -> login");
                        this.$router.push("/login");
                    }
                );
        },
        api_offene_vorgaenge_url() {
            return this.server_base_url()
                + '/api/vorgaenge/customer/'
                + this.customer
                + '/offen';
        },
        get_vorgang_infos() {
            let url = this.api_vorgang_infos_url();
            console.log(url);
            
            axios
                .get(url)
                .then(
                    response => {
                        this.ean = response.data.ean;
                        if (response.data['cropped_cover']['90']['existiert'] == 1) {
                            this.url_fuer_cropped_coverbild_90 = response.data['cropped_cover']['90']['url'] + "?random=" + Math.random();
                        }
                        if (response.data['cropped_cover']['200']['existiert'] == 1) {
                            this.url_fuer_cropped_coverbild_200 = response.data['cropped_cover']['200']['url']  + "?random=" + Math.random();
                        }
                        if (this.ean) {
                            // ich habe die EAN, jetzt Titel, Autor... von Findus-API holen
                            this.get_mediendetails_von_findus_api();
                            this.freigabe_ist_moeglich = true;
                        } else {
                            this.freigabe_ist_moeglich = false;
                        }
                    }
                )
                .catch(
                    () => {
                        console.log("unauthorized -> login");
                        this.$router.push("/login");
                    }
                );
        },
        deaktiviere_buttons_weil_freigabe_nicht_moeglich() {
            // ich habe vermutlich keine EAN-Nummer bekommen, dann kann ich auch keine Freigabe machen

        },
        api_vorgang_infos_url() {
            return this.server_base_url()
                + '/api/vorgang/'
                + this.vorgang_id
                + '/customer/'
                + this.customer
                + '/info';
        },
        // das schreibe ich rechts hin damit der User ein paar Details zum Medium sieht
        // es könnten auch die cropped covers mit ihren URLs mitgeliefert werden
        get_mediendetails_von_findus_api() {
            let url = this.api_mediendetails_url();
            console.log(url);
            
            axios
                .get(url)
                .then(
                    response => {
                        this.autor = response.data.autor;
                        this.titel = response.data.titel;
                        if (! this.ean && response.data.ean) {
                            this.ean = response.data.ean;
                        } else {
                            this.ean_herkunft = "EAN ist von Vorgang selbst, nicht Bücherei";
                        }
                        this.barcode = response.data.barcode;
                    }
                )
                .catch(
                    () => {
                        console.log("unauthorized -> login");
                        this.$router.push("/login");
                    }
                );
        },
        api_mediendetails_url() {
            // http://mycover.buchabfrage.de/api/mediendetails/customer/zirndorf/ean/9783492308564
            return this.server_base_url()
                + '/api/mediendetails/customer/'
                + this.customer
                + '/ean/'
                + this.ean;
        },
        url_fuer_coverbild() {
            return this.server_base_url()
                + '/upload/cover/'
                + this.customer
                + '/' + this.vorgang_id
                + '/cover.jpg';
        }
    }
}
</script>

<style scoped>
.cropped_cover {
    margin-top:10px;
    margin-bottom:10px;
    margin-left: 5px;
}

</style>


